import {
  ClientEntity,
  OrganizationInformation,
  clientAddressIsPrimary,
  toOrganizationAddress,
  toTelecomNumbers
} from "@common-core/coat-operational-hierarchy-appsync-model";

export const toOrganizationInformation = (
  source: ClientEntity
): OrganizationInformation => ({
  dbaName: source.custName,
  legalName: source.custLegalName,
  // Per Mackenzie, it's ok to set status as IN BUSINESS on create
  status: "IN BUSINESS",
  telecomNumbers: toTelecomNumbers(source.custPhoneNumber),
  address:
    source.addresses && source.addresses.length > 0
      ? toOrganizationAddress(
          source.addresses.find(clientAddressIsPrimary) || source.addresses[0]
        )
      : undefined
});
